import Vue from 'vue';
import { apiPath } from '../constants';

export const AppSalesReport = Vue.resource(
  `${apiPath}/finance/sales-file/`,
  {},
  {},
  { responseType: 'blob' },
);

export default AppSalesReport;
